import { Link } from "react-router-dom";
import { ArrowUpRight, Leaf, LineChart } from "lucide-react";

const pillars = [
  {
    id: "ernaehrung",
    href: "/gesundheit",
    eyebrow: "Gesundheit",
    title: "Gesundheit, so individuell wie du!",
    sub: "Wenn dein Körper sich meldet, steckt oft mehr dahinter.",
    description:
      "Verstehe deine Symptome und finde deinen Weg zurück ins Gleichgewicht — nach dem Ansatz von Anthony William, sanft und alltagstauglich.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/95c0696e-38c6-4b0c-80e9-86ee9a68795b/images/7e7a04fafc8a154c175a87e02095ee2aa86d6340079bffae9238cc4a1c91a88c.png",
    Icon: Leaf,
    chip: "bg-sage-400 text-bone-50",
    cta: "bg-sage-500 hover:bg-sage-600 text-bone-50",
  },
  {
    id: "finanzen",
    href: "/finanzen",
    eyebrow: "Finanzen",
    title: "Finanzen so, wie du sie brauchst",
    sub: "System statt Zufall.",
    description:
      "Entdecke deine Möglichkeiten und bringe mehr Leichtigkeit und Struktur in deine Finanzen. ",
    image:
      "https://static.prod-images.emergentagent.com/jobs/95c0696e-38c6-4b0c-80e9-86ee9a68795b/images/17c13b133b4c32eda39568d9820a8df85b7c0b71d71cf28d8afeeae7812099c1.png",
    Icon: LineChart,
    chip: "bg-clay-400 text-bone-50",
    cta: "bg-clay-500 hover:bg-clay-600 text-bone-50",
  },
];

export default function Pillars() {
  return (
    <section
      id="leistungen"
      data-testid="pillars-section"
      className="relative py-24 md:py-32 bg-bone-100"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="font-mono-fine text-[11px] tracking-[0.28em] uppercase text-sage-600">
            Leistungen
          </span>
          <h2 className="mt-4 font-display font-light text-4xl md:text-5xl lg:text-[3.75rem] leading-[1] tracking-[-0.03em] text-ink-900">
            Zwei Bereiche. <span className="italic font-normal">Ein gemeinsames Fundament.</span>
          </h2>
          <p className="mt-6 text-ink-700 text-[16.5px] leading-[1.75]">
            <b>Gesundheit</b> und <b>Finanzen</b> hängen enger zusammen, als die meisten denken. Wer finanziell unter Druck steht, schläft schlechter, ernährt sich schlechter, ist dauerhaft angespannt. Und wer gesundheitlich kämpft, hat schlicht keine <b>Energie</b>, sein Leben aktiv zu gestalten. Deswegen betrachte ich beides gemeinsam, damit das eine das andere stützt und nicht sabotiert.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {pillars.map((p) => (
            <article
              key={p.id}
              data-testid={`pillar-card-${p.id}`}
              className="group relative bg-bone-50 border border-bone-300 rounded-[2rem] overflow-hidden hover:shadow-lift hover:-translate-y-1 transition-all duration-500 flex flex-col"
            >
              <div className="relative h-64 md:h-72 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                />
                <div className={`absolute top-5 left-5 inline-flex items-center gap-2 px-3.5 h-8 rounded-full font-mono-fine text-[11px] tracking-[0.2em] uppercase ${p.chip}`}>
                  <p.Icon strokeWidth={1.75} className="w-3.5 h-3.5" />
                  {p.eyebrow}
                </div>
              </div>
              <div className="p-8 md:p-10 flex-1 flex flex-col">
                <h3 className="font-display font-light text-[1.9rem] md:text-[2.25rem] leading-[1.05] tracking-[-0.025em] text-ink-900">
                  {p.title}
                </h3>
                <p className="mt-3 text-[15px] tracking-wide text-ink-500 italic">{p.sub}</p>
                <p className="mt-4 text-ink-700 leading-relaxed">{p.description}</p>
                <div className="mt-auto pt-8">
                  <Link
                    to={p.href}
                    data-testid={`pillar-cta-${p.id}`}
                    className={`group/cta inline-flex items-center gap-3 pl-6 pr-2 h-12 rounded-full text-[13.5px] tracking-wide transition-all duration-300 hover:-translate-y-0.5 ${p.cta}`}
                  >
                    Mehr erfahren
                    <span className="w-9 h-9 rounded-full bg-bone-50/25 backdrop-blur-sm flex items-center justify-center transition-transform group-hover/cta:rotate-45">
                      <ArrowUpRight strokeWidth={1.75} className="w-4 h-4" />
                    </span>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
